package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BlockTransition(
    @SerialName("in") val inAnim: AnimationType? = null,
    @SerialName("out") val outAnim: AnimationType? = null,
    @SerialName("delay") val delay: Float = 0f,
)

@Serializable
enum class AnimationType {
    @SerialName("fade") Fade,
    @SerialName("slide_out") SlideOut,
    @SerialName("none") None,
}
